import { Color, RepeatWrapping, ShaderMaterial, Vector2 } from 'three';
import vertexShader from './backgroundVertex.glsl';
import fragmentShader from './backgroundFragment.glsl';
import AppEngine from './appEngine';

export default class BackgroundMaterial extends ShaderMaterial {
  constructor(texture) {
    texture.wrapS = RepeatWrapping;
    texture.wrapT = RepeatWrapping;
    const uniforms = {
      tDiffuse: { value: texture },
      exposure: { value: AppEngine.HDR_SCALE },
      offset1: { value: new Vector2(0.3, 0.7) },
      offset2: { value: new Vector2(0.7, 0.2) },
      color: { value: new Color(0x161853) },
    };
    super({
      uniforms,
      vertexShader,
      fragmentShader,
      depthWrite: false,
    });
  }
}
